import { z } from 'zod';

export const nullablePositiveNumberSchema = z
  .union([z.literal(''), z.coerce.number().min(0)])
  .transform(value => (value === '' ? null : value));

export const toNullableTrimmedString = (value?: string | null) =>
  value?.trim() || null;

export const toFormNumberValue = (value?: number | null) =>
  value == null ? '' : String(value);
